<template>
  <v-row class="pt-5">
    <v-col cols="10" offset="1">
      <v-row v-if="doc">
        <div v-for="card in doc.selectedTiles" :key="card.id" :data-id="card.id" :style="{ width: computedWidth }">
          <show-card :card="card" :cols="cols"></show-card>
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { ShowCard } from "@/components/core";

export default {
  name: "ResultsTileBoard",
  data() {
    return {
      doc: null,
      cols: 4,
    };
  },
  props: {
    id: String,
    model: String,
    localTiles: Array,
  },
  components: {
    ShowCard,
  },
  mounted() {
    this.getExercise(this.id);
  },
  watch: {
    id(val) {
      if (val) {
        this.getExercise(val);
      }
    },
  },
  computed: {
    computedWidth() {
      switch (this.cols) {
        case 1:
          return "100%";
        case 2:
          return "50%";
        case 3:
          return "33.33%";
        case 4:
          return "25%";
        case 5:
          return "20%";
        case 6:
          return "16.666666666666667%";
        case 7:
          return "14.285714285714286%";
        case 8:
          return "12.5%";
        case 9:
          return "11.111111111111111%";
        case 10:
          return "10%";
        default:
          return "25%";
      }
    },
  },
  methods: {
    getExercise(id) {
      // this.doc = null;
      let ref = fb[this.model]
        .where("id", "==", id)
        .where("pid", "==", this.$route.params.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.cols = items[0].cols;
            this.doc = items[0];
          }
        })
        .catch(function () { });
    },
  },
};
</script>
